import script from "./ServiceTeamsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceTeamsView.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceTeamsView.vue?vue&type=style&index=0&id=941b8132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-941b8132"]])

export default __exports__